import React, { useState } from 'react';
import Copy from '@/assets/copy-simple-light.svg';
import classNames from 'classnames';

type ICopyTextBtnProps = {
  copyText: string;
  copyHtmlContent?: string;
  placement?: 'left' | 'right';
  active?: boolean;
  children?: React.ReactNode;
  className?: string;
  showCopiedFeedback?: boolean;
};
const CopyTextBtn = ({
  copyText,
  copyHtmlContent,
  placement = 'left',
  active = false,
  children,
  className,
  showCopiedFeedback = false,
  ...props
}: ICopyTextBtnProps) => {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (showCopiedFeedback) {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
    navigator.clipboard.write([
      new ClipboardItem({
        'text/html': new Blob([copyHtmlContent || copyText], { type: 'text/html' }),
        'text/plain': new Blob([copyText], { type: 'text/plain' }),
      }),
    ]);
  };

  return (
    <div
      className={classNames(
        "group/copy relative before:absolute before:-top-8 before:left-0 before:h-8 before:w-full before:content-['']",
        className,
      )}
      {...props}
    >
      {children}

      {copied && (
        <div
          className={classNames(
            'absolute -top-17 rounded-full bg-white px-3 py-1',
            placement === 'right' ? 'right-0' : 'left-0',
          )}
        >
          Copied...
        </div>
      )}

      {active && copyText && (
        <button
          className={classNames(
            'absolute -top-8 hidden cursor-pointer rounded-lg bg-white p-1 opacity-0 transition-opacity group-hover/copy:block group-hover/copy:opacity-100',
            placement === 'right' ? 'right-0' : 'left-0',
          )}
          onClick={copyToClipboard}
          title="Copy to clipboard"
        >
          <Copy className="h-6 w-6" />
        </button>
      )}
    </div>
  );
};

export default CopyTextBtn;
